import React from "react"
import { toPartialGridItemProduct } from "../../../../features/algolia/converters"
import { AlgoliaProductVariant } from "../../../../features/algolia/types/doc"
import { trackClickedProduct } from "../../../../features/tracking"
import { PartialGridItemProduct } from "../../../../ui/organisms/Product/ProductGridItem/types"
import ProductGridWrapper from "../../../../ui/organisms/Product/ProductGridWrapper"
import { CustomRow } from "../../../../ui/spacings"
import { useAlgoliaSerpUi } from "../../context/ui"
import { useAlgoliaSearchState } from "../controller/state"

export const AlgoliaSerpHits = () => {
  const { sidebarCollapsed } = useAlgoliaSerpUi()
  const { searchResults, queryID } = useAlgoliaSearchState()

  const handleResultClick = (
    product: PartialGridItemProduct,
    index: number
  ) => {
    try {
      trackClickedProduct({
        variant: product.defaultVariant,
        searchId: queryID,
        position: searchResults.page * searchResults.hitsPerPage + index + 1,
      })
    } catch (e) {
      console.error("Error tracking result click", e)
    }
  }

  return (
    <CustomRow>
      <ProductGridWrapper
        products={searchResults?.hits?.map((x: AlgoliaProductVariant) =>
          toPartialGridItemProduct(x)
        )}
        onClick={handleResultClick}
        xsColSize={6}
        mdColSize={4}
        lgColSize={sidebarCollapsed ? 2 : 3}
        xlColSize={sidebarCollapsed ? 2 : 3}
        className="mb-16 sm:mb-10"
      />
    </CustomRow>
  )
}
